

import {
  mk_query,
  mk_rel_query,
  RelationBuilder,
  RelationsOf,
  FilterBuilderComplex,
  FilterBuilderBoolean,
  FilterBuilderNumber,
  FilterBuilderString,
  FilterBuilderCollection,
  FilterBuilderDate,
  parseBoolean,
  parseNumber,
  parseString,
  parseDate,
  EntityParser,
  parseCollection,
  parseEntity,
  succes,
  parseNullBoolean,
  parseNullNumber,
  parseNullDate,
  parseNullString,
  OrderByBuilderComplex,
  OrderByProp
} from "typescript-odata-client"
import { List } from "immutable"


const mk_prefix = (id: string, prefix?: string) => prefix ? prefix + '/' + id : id



  export const ActivityQuery = (uri?: string) => mk_query<Activity>(
    FilterBuilderActivity(), 
    ActivityRelationBuilder,
    uri != undefined ? uri + 'Activity' : 'http://localhost:5000/odata/Activity',
    ActivityParser,
    ActivityOrderBy("")
  )

  export const Activity_ActivityEditionNQuery = (uri?: string) => mk_query<Activity_ActivityEditionN>(
    FilterBuilderActivity_ActivityEditionN(), 
    Activity_ActivityEditionNRelationBuilder,
    uri != undefined ? uri + 'Activity_ActivityEditionN' : 'http://localhost:5000/odata/Activity_ActivityEditionN',
    Activity_ActivityEditionNParser,
    Activity_ActivityEditionNOrderBy("")
  )

  export const Activity_ActivityEditionScheduleQuery = (uri?: string) => mk_query<Activity_ActivityEditionSchedule>(
    FilterBuilderActivity_ActivityEditionSchedule(), 
    Activity_ActivityEditionScheduleRelationBuilder,
    uri != undefined ? uri + 'Activity_ActivityEditionSchedule' : 'http://localhost:5000/odata/Activity_ActivityEditionSchedule',
    Activity_ActivityEditionScheduleParser,
    Activity_ActivityEditionScheduleOrderBy("")
  )

  export const Activity_ArchivedActivityEditionNQuery = (uri?: string) => mk_query<Activity_ArchivedActivityEditionN>(
    FilterBuilderActivity_ArchivedActivityEditionN(), 
    Activity_ArchivedActivityEditionNRelationBuilder,
    uri != undefined ? uri + 'Activity_ArchivedActivityEditionN' : 'http://localhost:5000/odata/Activity_ArchivedActivityEditionN',
    Activity_ArchivedActivityEditionNParser,
    Activity_ArchivedActivityEditionNOrderBy("")
  )

  export const ActivityClusterQuery = (uri?: string) => mk_query<ActivityCluster>(
    FilterBuilderActivityCluster(), 
    ActivityClusterRelationBuilder,
    uri != undefined ? uri + 'ActivityCluster' : 'http://localhost:5000/odata/ActivityCluster',
    ActivityClusterParser,
    ActivityClusterOrderBy("")
  )

  export const ActivityCluster_ActivityQuery = (uri?: string) => mk_query<ActivityCluster_Activity>(
    FilterBuilderActivityCluster_Activity(), 
    ActivityCluster_ActivityRelationBuilder,
    uri != undefined ? uri + 'ActivityCluster_Activity' : 'http://localhost:5000/odata/ActivityCluster_Activity',
    ActivityCluster_ActivityParser,
    ActivityCluster_ActivityOrderBy("")
  )

  export const ActivityEditionNQuery = (uri?: string) => mk_query<ActivityEditionN>(
    FilterBuilderActivityEditionN(), 
    ActivityEditionNRelationBuilder,
    uri != undefined ? uri + 'ActivityEditionN' : 'http://localhost:5000/odata/ActivityEditionN',
    ActivityEditionNParser,
    ActivityEditionNOrderBy("")
  )

  export const ActivityEditionN_ActivityEditionScheduleQuery = (uri?: string) => mk_query<ActivityEditionN_ActivityEditionSchedule>(
    FilterBuilderActivityEditionN_ActivityEditionSchedule(), 
    ActivityEditionN_ActivityEditionScheduleRelationBuilder,
    uri != undefined ? uri + 'ActivityEditionN_ActivityEditionSchedule' : 'http://localhost:5000/odata/ActivityEditionN_ActivityEditionSchedule',
    ActivityEditionN_ActivityEditionScheduleParser,
    ActivityEditionN_ActivityEditionScheduleOrderBy("")
  )

  export const ActivityEditionN_ActivityEventQuery = (uri?: string) => mk_query<ActivityEditionN_ActivityEvent>(
    FilterBuilderActivityEditionN_ActivityEvent(), 
    ActivityEditionN_ActivityEventRelationBuilder,
    uri != undefined ? uri + 'ActivityEditionN_ActivityEvent' : 'http://localhost:5000/odata/ActivityEditionN_ActivityEvent',
    ActivityEditionN_ActivityEventParser,
    ActivityEditionN_ActivityEventOrderBy("")
  )

  export const ActivityEditionN_BookQuery = (uri?: string) => mk_query<ActivityEditionN_Book>(
    FilterBuilderActivityEditionN_Book(), 
    ActivityEditionN_BookRelationBuilder,
    uri != undefined ? uri + 'ActivityEditionN_Book' : 'http://localhost:5000/odata/ActivityEditionN_Book',
    ActivityEditionN_BookParser,
    ActivityEditionN_BookOrderBy("")
  )

  export const ActivityEditionScheduleQuery = (uri?: string) => mk_query<ActivityEditionSchedule>(
    FilterBuilderActivityEditionSchedule(), 
    ActivityEditionScheduleRelationBuilder,
    uri != undefined ? uri + 'ActivityEditionSchedule' : 'http://localhost:5000/odata/ActivityEditionSchedule',
    ActivityEditionScheduleParser,
    ActivityEditionScheduleOrderBy("")
  )

  export const ActivityEventQuery = (uri?: string) => mk_query<ActivityEvent>(
    FilterBuilderActivityEvent(), 
    ActivityEventRelationBuilder,
    uri != undefined ? uri + 'ActivityEvent' : 'http://localhost:5000/odata/ActivityEvent',
    ActivityEventParser,
    ActivityEventOrderBy("")
  )

  export const AdminQuery = (uri?: string) => mk_query<Admin>(
    FilterBuilderAdmin(), 
    AdminRelationBuilder,
    uri != undefined ? uri + 'Admin' : 'http://localhost:5000/odata/Admin',
    AdminParser,
    AdminOrderBy("")
  )

  export const ArchivedActivityEditionNQuery = (uri?: string) => mk_query<ArchivedActivityEditionN>(
    FilterBuilderArchivedActivityEditionN(), 
    ArchivedActivityEditionNRelationBuilder,
    uri != undefined ? uri + 'ArchivedActivityEditionN' : 'http://localhost:5000/odata/ArchivedActivityEditionN',
    ArchivedActivityEditionNParser,
    ArchivedActivityEditionNOrderBy("")
  )

  export const ArchivedActivityEditionN_ArchivedActivityEventQuery = (uri?: string) => mk_query<ArchivedActivityEditionN_ArchivedActivityEvent>(
    FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(), 
    ArchivedActivityEditionN_ArchivedActivityEventRelationBuilder,
    uri != undefined ? uri + 'ArchivedActivityEditionN_ArchivedActivityEvent' : 'http://localhost:5000/odata/ArchivedActivityEditionN_ArchivedActivityEvent',
    ArchivedActivityEditionN_ArchivedActivityEventParser,
    ArchivedActivityEditionN_ArchivedActivityEventOrderBy("")
  )

  export const ArchivedActivityEditionN_BookQuery = (uri?: string) => mk_query<ArchivedActivityEditionN_Book>(
    FilterBuilderArchivedActivityEditionN_Book(), 
    ArchivedActivityEditionN_BookRelationBuilder,
    uri != undefined ? uri + 'ArchivedActivityEditionN_Book' : 'http://localhost:5000/odata/ArchivedActivityEditionN_Book',
    ArchivedActivityEditionN_BookParser,
    ArchivedActivityEditionN_BookOrderBy("")
  )

  export const ArchivedActivityEventQuery = (uri?: string) => mk_query<ArchivedActivityEvent>(
    FilterBuilderArchivedActivityEvent(), 
    ArchivedActivityEventRelationBuilder,
    uri != undefined ? uri + 'ArchivedActivityEvent' : 'http://localhost:5000/odata/ArchivedActivityEvent',
    ArchivedActivityEventParser,
    ArchivedActivityEventOrderBy("")
  )

  export const BookQuery = (uri?: string) => mk_query<Book>(
    FilterBuilderBook(), 
    BookRelationBuilder,
    uri != undefined ? uri + 'Book' : 'http://localhost:5000/odata/Book',
    BookParser,
    BookOrderBy("")
  )

  export const Book_ImageDataQuery = (uri?: string) => mk_query<Book_ImageData>(
    FilterBuilderBook_ImageData(), 
    Book_ImageDataRelationBuilder,
    uri != undefined ? uri + 'Book_ImageData' : 'http://localhost:5000/odata/Book_ImageDatum',
    Book_ImageDataParser,
    Book_ImageDataOrderBy("")
  )

  export const ControlPanelQuery = (uri?: string) => mk_query<ControlPanel>(
    FilterBuilderControlPanel(), 
    ControlPanelRelationBuilder,
    uri != undefined ? uri + 'ControlPanel' : 'http://localhost:5000/odata/ControlPanel',
    ControlPanelParser,
    ControlPanelOrderBy("")
  )

  export const HomePageQuery = (uri?: string) => mk_query<HomePage>(
    FilterBuilderHomePage(), 
    HomePageRelationBuilder,
    uri != undefined ? uri + 'HomePage' : 'http://localhost:5000/odata/HomePage',
    HomePageParser,
    HomePageOrderBy("")
  )

  export const LocationQuery = (uri?: string) => mk_query<Location>(
    FilterBuilderLocation(), 
    LocationRelationBuilder,
    uri != undefined ? uri + 'Location' : 'http://localhost:5000/odata/Location',
    LocationParser,
    LocationOrderBy("")
  )

  export const Location_ActivityEditionScheduleQuery = (uri?: string) => mk_query<Location_ActivityEditionSchedule>(
    FilterBuilderLocation_ActivityEditionSchedule(), 
    Location_ActivityEditionScheduleRelationBuilder,
    uri != undefined ? uri + 'Location_ActivityEditionSchedule' : 'http://localhost:5000/odata/Location_ActivityEditionSchedule',
    Location_ActivityEditionScheduleParser,
    Location_ActivityEditionScheduleOrderBy("")
  )

  export const Location_ActivityEventQuery = (uri?: string) => mk_query<Location_ActivityEvent>(
    FilterBuilderLocation_ActivityEvent(), 
    Location_ActivityEventRelationBuilder,
    uri != undefined ? uri + 'Location_ActivityEvent' : 'http://localhost:5000/odata/Location_ActivityEvent',
    Location_ActivityEventParser,
    Location_ActivityEventOrderBy("")
  )

  export const Location_ArchivedActivityEventQuery = (uri?: string) => mk_query<Location_ArchivedActivityEvent>(
    FilterBuilderLocation_ArchivedActivityEvent(), 
    Location_ArchivedActivityEventRelationBuilder,
    uri != undefined ? uri + 'Location_ArchivedActivityEvent' : 'http://localhost:5000/odata/Location_ArchivedActivityEvent',
    Location_ArchivedActivityEventParser,
    Location_ArchivedActivityEventOrderBy("")
  )

  export const LoginAttemptQuery = (uri?: string) => mk_query<LoginAttempt>(
    FilterBuilderLoginAttempt(), 
    LoginAttemptRelationBuilder,
    uri != undefined ? uri + 'LoginAttempt' : 'http://localhost:5000/odata/LoginAttempt',
    LoginAttemptParser,
    LoginAttemptOrderBy("")
  )

  export const PermanentRedirectQuery = (uri?: string) => mk_query<PermanentRedirect>(
    FilterBuilderPermanentRedirect(), 
    PermanentRedirectRelationBuilder,
    uri != undefined ? uri + 'PermanentRedirect' : 'http://localhost:5000/odata/PermanentRedirect',
    PermanentRedirectParser,
    PermanentRedirectOrderBy("")
  )

  export const RegionQuery = (uri?: string) => mk_query<Region>(
    FilterBuilderRegion(), 
    RegionRelationBuilder,
    uri != undefined ? uri + 'Region' : 'http://localhost:5000/odata/Region',
    RegionParser,
    RegionOrderBy("")
  )

  export const Region_LocationQuery = (uri?: string) => mk_query<Region_Location>(
    FilterBuilderRegion_Location(), 
    Region_LocationRelationBuilder,
    uri != undefined ? uri + 'Region_Location' : 'http://localhost:5000/odata/Region_Location',
    Region_LocationParser,
    Region_LocationOrderBy("")
  )

  export const SessionQuery = (uri?: string) => mk_query<Session>(
    FilterBuilderSession(), 
    SessionRelationBuilder,
    uri != undefined ? uri + 'Session' : 'http://localhost:5000/odata/Session',
    SessionParser,
    SessionOrderBy("")
  )



export type Activity = {
    Id: number
    CreatedDate: Date
    Title: string | null
    Sticky: boolean
    StickyTip: boolean
    HideInOverview: boolean
} & {
  Activity_ActivityEditionN: List<Activity_ActivityEditionN>
    Activity_ActivityEditionSchedule: List<Activity_ActivityEditionSchedule>
    Activity_ArchivedActivityEditionN: List<Activity_ArchivedActivityEditionN>
    ActivityCluster_Activity: List<ActivityCluster_Activity>
}


function FilterBuilderActivity(prefix?: string) : FilterBuilderComplex<Activity> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Title: new FilterBuilderString(mk_prefix('Title', prefix)),
      Sticky: new FilterBuilderBoolean(mk_prefix('Sticky', prefix)),
      StickyTip: new FilterBuilderBoolean(mk_prefix('StickyTip', prefix)),
      HideInOverview: new FilterBuilderBoolean(mk_prefix('HideInOverview', prefix)),
    Activity_ActivityEditionN: new FilterBuilderCollection<Activity_ActivityEditionN>(mk_prefix('Activity_ActivityEditionN', prefix), s => FilterBuilderActivity_ActivityEditionN(s)),
      Activity_ActivityEditionSchedule: new FilterBuilderCollection<Activity_ActivityEditionSchedule>(mk_prefix('Activity_ActivityEditionSchedule', prefix), s => FilterBuilderActivity_ActivityEditionSchedule(s)),
      Activity_ArchivedActivityEditionN: new FilterBuilderCollection<Activity_ArchivedActivityEditionN>(mk_prefix('Activity_ArchivedActivityEditionN', prefix), s => FilterBuilderActivity_ArchivedActivityEditionN(s)),
      ActivityCluster_Activity: new FilterBuilderCollection<ActivityCluster_Activity>(mk_prefix('ActivityCluster_Activity', prefix), s => FilterBuilderActivityCluster_Activity(s)),
  }
}


const ActivityRelationBuilder: RelationBuilder<RelationsOf<Activity>> = {
Activity_ActivityEditionN: () => mk_rel_query(
    'Activity_ActivityEditionN',
    FilterBuilderActivity_ActivityEditionN(),
    Activity_ActivityEditionNRelationBuilder,
    Activity_ActivityEditionNParser
  ),

Activity_ActivityEditionSchedule: () => mk_rel_query(
    'Activity_ActivityEditionSchedule',
    FilterBuilderActivity_ActivityEditionSchedule(),
    Activity_ActivityEditionScheduleRelationBuilder,
    Activity_ActivityEditionScheduleParser
  ),

Activity_ArchivedActivityEditionN: () => mk_rel_query(
    'Activity_ArchivedActivityEditionN',
    FilterBuilderActivity_ArchivedActivityEditionN(),
    Activity_ArchivedActivityEditionNRelationBuilder,
    Activity_ArchivedActivityEditionNParser
  ),

ActivityCluster_Activity: () => mk_rel_query(
    'ActivityCluster_Activity',
    FilterBuilderActivityCluster_Activity(),
    ActivityCluster_ActivityRelationBuilder,
    ActivityCluster_ActivityParser
  ),

}


const  ActivityParser : EntityParser<Activity>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Title: parseNullString,
      Sticky: parseBoolean,
      StickyTip: parseBoolean,
      HideInOverview: parseBoolean,
  Activity_ActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      Activity_ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
      Activity_ArchivedActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      ActivityCluster_Activity: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityOrderBy : (p: string) => OrderByBuilderComplex<Activity> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Title:  new OrderByProp(p ? p + "/Title" : "Title"),
      Sticky:  new OrderByProp(p ? p + "/Sticky" : "Sticky"),
      StickyTip:  new OrderByProp(p ? p + "/StickyTip" : "StickyTip"),
      HideInOverview:  new OrderByProp(p ? p + "/HideInOverview" : "HideInOverview"),
  Activity_ActivityEditionN:  p => Activity_ActivityEditionNOrderBy(p ? p + "/Activity_ActivityEditionN" : "Activity_ActivityEditionN"),
      Activity_ActivityEditionSchedule:  p => Activity_ActivityEditionScheduleOrderBy(p ? p + "/Activity_ActivityEditionSchedule" : "Activity_ActivityEditionSchedule"),
      Activity_ArchivedActivityEditionN:  p => Activity_ArchivedActivityEditionNOrderBy(p ? p + "/Activity_ArchivedActivityEditionN" : "Activity_ArchivedActivityEditionN"),
      ActivityCluster_Activity:  p => ActivityCluster_ActivityOrderBy(p ? p + "/ActivityCluster_Activity" : "ActivityCluster_Activity"),
})



export type Activity_ActivityEditionN = {
    Id: number
    ActivityId: number
    ActivityEditionNId: number
} & {
  ActivityEditionN: List<ActivityEditionN>
    Activity: List<Activity>
}


function FilterBuilderActivity_ActivityEditionN(prefix?: string) : FilterBuilderComplex<Activity_ActivityEditionN> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ActivityId: new FilterBuilderNumber(mk_prefix('ActivityId', prefix)),
      ActivityEditionNId: new FilterBuilderNumber(mk_prefix('ActivityEditionNId', prefix)),
    ActivityEditionN: new FilterBuilderCollection<ActivityEditionN>(mk_prefix('ActivityEditionN', prefix), s => FilterBuilderActivityEditionN(s)),
      Activity: new FilterBuilderCollection<Activity>(mk_prefix('Activity', prefix), s => FilterBuilderActivity(s)),
  }
}


const Activity_ActivityEditionNRelationBuilder: RelationBuilder<RelationsOf<Activity_ActivityEditionN>> = {
ActivityEditionN: () => mk_rel_query(
    'ActivityEditionN',
    FilterBuilderActivityEditionN(),
    ActivityEditionNRelationBuilder,
    ActivityEditionNParser
  ),

Activity: () => mk_rel_query(
    'Activity',
    FilterBuilderActivity(),
    ActivityRelationBuilder,
    ActivityParser
  ),

}


const  Activity_ActivityEditionNParser : EntityParser<Activity_ActivityEditionN>= {
  Id: parseNumber,
      ActivityId: parseNumber,
      ActivityEditionNId: parseNumber,
  ActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      Activity: p => parseCollection(x => parseEntity(x, p)),
}


const Activity_ActivityEditionNOrderBy : (p: string) => OrderByBuilderComplex<Activity_ActivityEditionN> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ActivityId:  new OrderByProp(p ? p + "/ActivityId" : "ActivityId"),
      ActivityEditionNId:  new OrderByProp(p ? p + "/ActivityEditionNId" : "ActivityEditionNId"),
  ActivityEditionN:  p => ActivityEditionNOrderBy(p ? p + "/ActivityEditionN" : "ActivityEditionN"),
      Activity:  p => ActivityOrderBy(p ? p + "/Activity" : "Activity"),
})



export type Activity_ActivityEditionSchedule = {
    Id: number
    ActivityId: number
    ActivityEditionScheduleId: number
} & {
  ActivityEditionSchedule: List<ActivityEditionSchedule>
    Activity: List<Activity>
}


function FilterBuilderActivity_ActivityEditionSchedule(prefix?: string) : FilterBuilderComplex<Activity_ActivityEditionSchedule> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ActivityId: new FilterBuilderNumber(mk_prefix('ActivityId', prefix)),
      ActivityEditionScheduleId: new FilterBuilderNumber(mk_prefix('ActivityEditionScheduleId', prefix)),
    ActivityEditionSchedule: new FilterBuilderCollection<ActivityEditionSchedule>(mk_prefix('ActivityEditionSchedule', prefix), s => FilterBuilderActivityEditionSchedule(s)),
      Activity: new FilterBuilderCollection<Activity>(mk_prefix('Activity', prefix), s => FilterBuilderActivity(s)),
  }
}


const Activity_ActivityEditionScheduleRelationBuilder: RelationBuilder<RelationsOf<Activity_ActivityEditionSchedule>> = {
ActivityEditionSchedule: () => mk_rel_query(
    'ActivityEditionSchedule',
    FilterBuilderActivityEditionSchedule(),
    ActivityEditionScheduleRelationBuilder,
    ActivityEditionScheduleParser
  ),

Activity: () => mk_rel_query(
    'Activity',
    FilterBuilderActivity(),
    ActivityRelationBuilder,
    ActivityParser
  ),

}


const  Activity_ActivityEditionScheduleParser : EntityParser<Activity_ActivityEditionSchedule>= {
  Id: parseNumber,
      ActivityId: parseNumber,
      ActivityEditionScheduleId: parseNumber,
  ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
      Activity: p => parseCollection(x => parseEntity(x, p)),
}


const Activity_ActivityEditionScheduleOrderBy : (p: string) => OrderByBuilderComplex<Activity_ActivityEditionSchedule> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ActivityId:  new OrderByProp(p ? p + "/ActivityId" : "ActivityId"),
      ActivityEditionScheduleId:  new OrderByProp(p ? p + "/ActivityEditionScheduleId" : "ActivityEditionScheduleId"),
  ActivityEditionSchedule:  p => ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionSchedule" : "ActivityEditionSchedule"),
      Activity:  p => ActivityOrderBy(p ? p + "/Activity" : "Activity"),
})



export type Activity_ArchivedActivityEditionN = {
    Id: number
    ActivityId: number
    ArchivedActivityEditionNId: number
} & {
  Activity: List<Activity>
    ArchivedActivityEditionN: List<ArchivedActivityEditionN>
}


function FilterBuilderActivity_ArchivedActivityEditionN(prefix?: string) : FilterBuilderComplex<Activity_ArchivedActivityEditionN> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ActivityId: new FilterBuilderNumber(mk_prefix('ActivityId', prefix)),
      ArchivedActivityEditionNId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEditionNId', prefix)),
    Activity: new FilterBuilderCollection<Activity>(mk_prefix('Activity', prefix), s => FilterBuilderActivity(s)),
      ArchivedActivityEditionN: new FilterBuilderCollection<ArchivedActivityEditionN>(mk_prefix('ArchivedActivityEditionN', prefix), s => FilterBuilderArchivedActivityEditionN(s)),
  }
}


const Activity_ArchivedActivityEditionNRelationBuilder: RelationBuilder<RelationsOf<Activity_ArchivedActivityEditionN>> = {
Activity: () => mk_rel_query(
    'Activity',
    FilterBuilderActivity(),
    ActivityRelationBuilder,
    ActivityParser
  ),

ArchivedActivityEditionN: () => mk_rel_query(
    'ArchivedActivityEditionN',
    FilterBuilderArchivedActivityEditionN(),
    ArchivedActivityEditionNRelationBuilder,
    ArchivedActivityEditionNParser
  ),

}


const  Activity_ArchivedActivityEditionNParser : EntityParser<Activity_ArchivedActivityEditionN>= {
  Id: parseNumber,
      ActivityId: parseNumber,
      ArchivedActivityEditionNId: parseNumber,
  Activity: p => parseCollection(x => parseEntity(x, p)),
      ArchivedActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
}


const Activity_ArchivedActivityEditionNOrderBy : (p: string) => OrderByBuilderComplex<Activity_ArchivedActivityEditionN> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ActivityId:  new OrderByProp(p ? p + "/ActivityId" : "ActivityId"),
      ArchivedActivityEditionNId:  new OrderByProp(p ? p + "/ArchivedActivityEditionNId" : "ArchivedActivityEditionNId"),
  Activity:  p => ActivityOrderBy(p ? p + "/Activity" : "Activity"),
      ArchivedActivityEditionN:  p => ArchivedActivityEditionNOrderBy(p ? p + "/ArchivedActivityEditionN" : "ArchivedActivityEditionN"),
})



export type ActivityCluster = {
    Id: number
    CreatedDate: Date
    Title: string | null
    Description: string | null
    Slug: string | null
} & {
  ActivityCluster_Activity: List<ActivityCluster_Activity>
}


function FilterBuilderActivityCluster(prefix?: string) : FilterBuilderComplex<ActivityCluster> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Title: new FilterBuilderString(mk_prefix('Title', prefix)),
      Description: new FilterBuilderString(mk_prefix('Description', prefix)),
      Slug: new FilterBuilderString(mk_prefix('Slug', prefix)),
    ActivityCluster_Activity: new FilterBuilderCollection<ActivityCluster_Activity>(mk_prefix('ActivityCluster_Activity', prefix), s => FilterBuilderActivityCluster_Activity(s)),
  }
}


const ActivityClusterRelationBuilder: RelationBuilder<RelationsOf<ActivityCluster>> = {
ActivityCluster_Activity: () => mk_rel_query(
    'ActivityCluster_Activity',
    FilterBuilderActivityCluster_Activity(),
    ActivityCluster_ActivityRelationBuilder,
    ActivityCluster_ActivityParser
  ),

}


const  ActivityClusterParser : EntityParser<ActivityCluster>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Title: parseNullString,
      Description: parseNullString,
      Slug: parseNullString,
  ActivityCluster_Activity: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityClusterOrderBy : (p: string) => OrderByBuilderComplex<ActivityCluster> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Title:  new OrderByProp(p ? p + "/Title" : "Title"),
      Description:  new OrderByProp(p ? p + "/Description" : "Description"),
      Slug:  new OrderByProp(p ? p + "/Slug" : "Slug"),
  ActivityCluster_Activity:  p => ActivityCluster_ActivityOrderBy(p ? p + "/ActivityCluster_Activity" : "ActivityCluster_Activity"),
})



export type ActivityCluster_Activity = {
    Id: number
    ActivityClusterId: number
    ActivityId: number
} & {
  ActivityCluster: List<ActivityCluster>
    Activity: List<Activity>
}


function FilterBuilderActivityCluster_Activity(prefix?: string) : FilterBuilderComplex<ActivityCluster_Activity> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ActivityClusterId: new FilterBuilderNumber(mk_prefix('ActivityClusterId', prefix)),
      ActivityId: new FilterBuilderNumber(mk_prefix('ActivityId', prefix)),
    ActivityCluster: new FilterBuilderCollection<ActivityCluster>(mk_prefix('ActivityCluster', prefix), s => FilterBuilderActivityCluster(s)),
      Activity: new FilterBuilderCollection<Activity>(mk_prefix('Activity', prefix), s => FilterBuilderActivity(s)),
  }
}


const ActivityCluster_ActivityRelationBuilder: RelationBuilder<RelationsOf<ActivityCluster_Activity>> = {
ActivityCluster: () => mk_rel_query(
    'ActivityCluster',
    FilterBuilderActivityCluster(),
    ActivityClusterRelationBuilder,
    ActivityClusterParser
  ),

Activity: () => mk_rel_query(
    'Activity',
    FilterBuilderActivity(),
    ActivityRelationBuilder,
    ActivityParser
  ),

}


const  ActivityCluster_ActivityParser : EntityParser<ActivityCluster_Activity>= {
  Id: parseNumber,
      ActivityClusterId: parseNumber,
      ActivityId: parseNumber,
  ActivityCluster: p => parseCollection(x => parseEntity(x, p)),
      Activity: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityCluster_ActivityOrderBy : (p: string) => OrderByBuilderComplex<ActivityCluster_Activity> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ActivityClusterId:  new OrderByProp(p ? p + "/ActivityClusterId" : "ActivityClusterId"),
      ActivityId:  new OrderByProp(p ? p + "/ActivityId" : "ActivityId"),
  ActivityCluster:  p => ActivityClusterOrderBy(p ? p + "/ActivityCluster" : "ActivityCluster"),
      Activity:  p => ActivityOrderBy(p ? p + "/Activity" : "Activity"),
})



export type ActivityEditionN = {
    Id: number
    CreatedDate: Date
    SignupText: string | null
    SignupURL: string | null
} & {
  Activity_ActivityEditionN: List<Activity_ActivityEditionN>
    ActivityEditionN_ActivityEditionSchedule: List<ActivityEditionN_ActivityEditionSchedule>
    ActivityEditionN_ActivityEvent: List<ActivityEditionN_ActivityEvent>
    ActivityEditionN_Book: List<ActivityEditionN_Book>
}


function FilterBuilderActivityEditionN(prefix?: string) : FilterBuilderComplex<ActivityEditionN> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      SignupText: new FilterBuilderString(mk_prefix('SignupText', prefix)),
      SignupURL: new FilterBuilderString(mk_prefix('SignupURL', prefix)),
    Activity_ActivityEditionN: new FilterBuilderCollection<Activity_ActivityEditionN>(mk_prefix('Activity_ActivityEditionN', prefix), s => FilterBuilderActivity_ActivityEditionN(s)),
      ActivityEditionN_ActivityEditionSchedule: new FilterBuilderCollection<ActivityEditionN_ActivityEditionSchedule>(mk_prefix('ActivityEditionN_ActivityEditionSchedule', prefix), s => FilterBuilderActivityEditionN_ActivityEditionSchedule(s)),
      ActivityEditionN_ActivityEvent: new FilterBuilderCollection<ActivityEditionN_ActivityEvent>(mk_prefix('ActivityEditionN_ActivityEvent', prefix), s => FilterBuilderActivityEditionN_ActivityEvent(s)),
      ActivityEditionN_Book: new FilterBuilderCollection<ActivityEditionN_Book>(mk_prefix('ActivityEditionN_Book', prefix), s => FilterBuilderActivityEditionN_Book(s)),
  }
}


const ActivityEditionNRelationBuilder: RelationBuilder<RelationsOf<ActivityEditionN>> = {
Activity_ActivityEditionN: () => mk_rel_query(
    'Activity_ActivityEditionN',
    FilterBuilderActivity_ActivityEditionN(),
    Activity_ActivityEditionNRelationBuilder,
    Activity_ActivityEditionNParser
  ),

ActivityEditionN_ActivityEditionSchedule: () => mk_rel_query(
    'ActivityEditionN_ActivityEditionSchedule',
    FilterBuilderActivityEditionN_ActivityEditionSchedule(),
    ActivityEditionN_ActivityEditionScheduleRelationBuilder,
    ActivityEditionN_ActivityEditionScheduleParser
  ),

ActivityEditionN_ActivityEvent: () => mk_rel_query(
    'ActivityEditionN_ActivityEvent',
    FilterBuilderActivityEditionN_ActivityEvent(),
    ActivityEditionN_ActivityEventRelationBuilder,
    ActivityEditionN_ActivityEventParser
  ),

ActivityEditionN_Book: () => mk_rel_query(
    'ActivityEditionN_Book',
    FilterBuilderActivityEditionN_Book(),
    ActivityEditionN_BookRelationBuilder,
    ActivityEditionN_BookParser
  ),

}


const  ActivityEditionNParser : EntityParser<ActivityEditionN>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      SignupText: parseNullString,
      SignupURL: parseNullString,
  Activity_ActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      ActivityEditionN_ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
      ActivityEditionN_ActivityEvent: p => parseCollection(x => parseEntity(x, p)),
      ActivityEditionN_Book: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityEditionNOrderBy : (p: string) => OrderByBuilderComplex<ActivityEditionN> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      SignupText:  new OrderByProp(p ? p + "/SignupText" : "SignupText"),
      SignupURL:  new OrderByProp(p ? p + "/SignupURL" : "SignupURL"),
  Activity_ActivityEditionN:  p => Activity_ActivityEditionNOrderBy(p ? p + "/Activity_ActivityEditionN" : "Activity_ActivityEditionN"),
      ActivityEditionN_ActivityEditionSchedule:  p => ActivityEditionN_ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionN_ActivityEditionSchedule" : "ActivityEditionN_ActivityEditionSchedule"),
      ActivityEditionN_ActivityEvent:  p => ActivityEditionN_ActivityEventOrderBy(p ? p + "/ActivityEditionN_ActivityEvent" : "ActivityEditionN_ActivityEvent"),
      ActivityEditionN_Book:  p => ActivityEditionN_BookOrderBy(p ? p + "/ActivityEditionN_Book" : "ActivityEditionN_Book"),
})



export type ActivityEditionN_ActivityEditionSchedule = {
    Id: number
    ActivityEditionNId: number
    ActivityEditionScheduleId: number
} & {
  ActivityEditionN: List<ActivityEditionN>
    ActivityEditionSchedule: List<ActivityEditionSchedule>
}


function FilterBuilderActivityEditionN_ActivityEditionSchedule(prefix?: string) : FilterBuilderComplex<ActivityEditionN_ActivityEditionSchedule> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ActivityEditionNId: new FilterBuilderNumber(mk_prefix('ActivityEditionNId', prefix)),
      ActivityEditionScheduleId: new FilterBuilderNumber(mk_prefix('ActivityEditionScheduleId', prefix)),
    ActivityEditionN: new FilterBuilderCollection<ActivityEditionN>(mk_prefix('ActivityEditionN', prefix), s => FilterBuilderActivityEditionN(s)),
      ActivityEditionSchedule: new FilterBuilderCollection<ActivityEditionSchedule>(mk_prefix('ActivityEditionSchedule', prefix), s => FilterBuilderActivityEditionSchedule(s)),
  }
}


const ActivityEditionN_ActivityEditionScheduleRelationBuilder: RelationBuilder<RelationsOf<ActivityEditionN_ActivityEditionSchedule>> = {
ActivityEditionN: () => mk_rel_query(
    'ActivityEditionN',
    FilterBuilderActivityEditionN(),
    ActivityEditionNRelationBuilder,
    ActivityEditionNParser
  ),

ActivityEditionSchedule: () => mk_rel_query(
    'ActivityEditionSchedule',
    FilterBuilderActivityEditionSchedule(),
    ActivityEditionScheduleRelationBuilder,
    ActivityEditionScheduleParser
  ),

}


const  ActivityEditionN_ActivityEditionScheduleParser : EntityParser<ActivityEditionN_ActivityEditionSchedule>= {
  Id: parseNumber,
      ActivityEditionNId: parseNumber,
      ActivityEditionScheduleId: parseNumber,
  ActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityEditionN_ActivityEditionScheduleOrderBy : (p: string) => OrderByBuilderComplex<ActivityEditionN_ActivityEditionSchedule> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ActivityEditionNId:  new OrderByProp(p ? p + "/ActivityEditionNId" : "ActivityEditionNId"),
      ActivityEditionScheduleId:  new OrderByProp(p ? p + "/ActivityEditionScheduleId" : "ActivityEditionScheduleId"),
  ActivityEditionN:  p => ActivityEditionNOrderBy(p ? p + "/ActivityEditionN" : "ActivityEditionN"),
      ActivityEditionSchedule:  p => ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionSchedule" : "ActivityEditionSchedule"),
})



export type ActivityEditionN_ActivityEvent = {
    Id: number
    ActivityEditionNId: number
    ActivityEventId: number
} & {
  ActivityEditionN: List<ActivityEditionN>
    ActivityEvent: List<ActivityEvent>
}


function FilterBuilderActivityEditionN_ActivityEvent(prefix?: string) : FilterBuilderComplex<ActivityEditionN_ActivityEvent> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ActivityEditionNId: new FilterBuilderNumber(mk_prefix('ActivityEditionNId', prefix)),
      ActivityEventId: new FilterBuilderNumber(mk_prefix('ActivityEventId', prefix)),
    ActivityEditionN: new FilterBuilderCollection<ActivityEditionN>(mk_prefix('ActivityEditionN', prefix), s => FilterBuilderActivityEditionN(s)),
      ActivityEvent: new FilterBuilderCollection<ActivityEvent>(mk_prefix('ActivityEvent', prefix), s => FilterBuilderActivityEvent(s)),
  }
}


const ActivityEditionN_ActivityEventRelationBuilder: RelationBuilder<RelationsOf<ActivityEditionN_ActivityEvent>> = {
ActivityEditionN: () => mk_rel_query(
    'ActivityEditionN',
    FilterBuilderActivityEditionN(),
    ActivityEditionNRelationBuilder,
    ActivityEditionNParser
  ),

ActivityEvent: () => mk_rel_query(
    'ActivityEvent',
    FilterBuilderActivityEvent(),
    ActivityEventRelationBuilder,
    ActivityEventParser
  ),

}


const  ActivityEditionN_ActivityEventParser : EntityParser<ActivityEditionN_ActivityEvent>= {
  Id: parseNumber,
      ActivityEditionNId: parseNumber,
      ActivityEventId: parseNumber,
  ActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      ActivityEvent: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityEditionN_ActivityEventOrderBy : (p: string) => OrderByBuilderComplex<ActivityEditionN_ActivityEvent> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ActivityEditionNId:  new OrderByProp(p ? p + "/ActivityEditionNId" : "ActivityEditionNId"),
      ActivityEventId:  new OrderByProp(p ? p + "/ActivityEventId" : "ActivityEventId"),
  ActivityEditionN:  p => ActivityEditionNOrderBy(p ? p + "/ActivityEditionN" : "ActivityEditionN"),
      ActivityEvent:  p => ActivityEventOrderBy(p ? p + "/ActivityEvent" : "ActivityEvent"),
})



export type ActivityEditionN_Book = {
    Id: number
    ActivityEditionNId: number
    BookId: number
} & {
  ActivityEditionN: List<ActivityEditionN>
    Book: List<Book>
}


function FilterBuilderActivityEditionN_Book(prefix?: string) : FilterBuilderComplex<ActivityEditionN_Book> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ActivityEditionNId: new FilterBuilderNumber(mk_prefix('ActivityEditionNId', prefix)),
      BookId: new FilterBuilderNumber(mk_prefix('BookId', prefix)),
    ActivityEditionN: new FilterBuilderCollection<ActivityEditionN>(mk_prefix('ActivityEditionN', prefix), s => FilterBuilderActivityEditionN(s)),
      Book: new FilterBuilderCollection<Book>(mk_prefix('Book', prefix), s => FilterBuilderBook(s)),
  }
}


const ActivityEditionN_BookRelationBuilder: RelationBuilder<RelationsOf<ActivityEditionN_Book>> = {
ActivityEditionN: () => mk_rel_query(
    'ActivityEditionN',
    FilterBuilderActivityEditionN(),
    ActivityEditionNRelationBuilder,
    ActivityEditionNParser
  ),

Book: () => mk_rel_query(
    'Book',
    FilterBuilderBook(),
    BookRelationBuilder,
    BookParser
  ),

}


const  ActivityEditionN_BookParser : EntityParser<ActivityEditionN_Book>= {
  Id: parseNumber,
      ActivityEditionNId: parseNumber,
      BookId: parseNumber,
  ActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      Book: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityEditionN_BookOrderBy : (p: string) => OrderByBuilderComplex<ActivityEditionN_Book> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ActivityEditionNId:  new OrderByProp(p ? p + "/ActivityEditionNId" : "ActivityEditionNId"),
      BookId:  new OrderByProp(p ? p + "/BookId" : "BookId"),
  ActivityEditionN:  p => ActivityEditionNOrderBy(p ? p + "/ActivityEditionN" : "ActivityEditionN"),
      Book:  p => BookOrderBy(p ? p + "/Book" : "Book"),
})



export type ActivityEditionSchedule = {
    Id: number
    CreatedDate: Date
    Plan: string | null
} & {
  Activity_ActivityEditionSchedule: List<Activity_ActivityEditionSchedule>
    ActivityEditionN_ActivityEditionSchedule: List<ActivityEditionN_ActivityEditionSchedule>
    Location_ActivityEditionSchedule: List<Location_ActivityEditionSchedule>
}


function FilterBuilderActivityEditionSchedule(prefix?: string) : FilterBuilderComplex<ActivityEditionSchedule> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Plan: new FilterBuilderString(mk_prefix('Plan', prefix)),
    Activity_ActivityEditionSchedule: new FilterBuilderCollection<Activity_ActivityEditionSchedule>(mk_prefix('Activity_ActivityEditionSchedule', prefix), s => FilterBuilderActivity_ActivityEditionSchedule(s)),
      ActivityEditionN_ActivityEditionSchedule: new FilterBuilderCollection<ActivityEditionN_ActivityEditionSchedule>(mk_prefix('ActivityEditionN_ActivityEditionSchedule', prefix), s => FilterBuilderActivityEditionN_ActivityEditionSchedule(s)),
      Location_ActivityEditionSchedule: new FilterBuilderCollection<Location_ActivityEditionSchedule>(mk_prefix('Location_ActivityEditionSchedule', prefix), s => FilterBuilderLocation_ActivityEditionSchedule(s)),
  }
}


const ActivityEditionScheduleRelationBuilder: RelationBuilder<RelationsOf<ActivityEditionSchedule>> = {
Activity_ActivityEditionSchedule: () => mk_rel_query(
    'Activity_ActivityEditionSchedule',
    FilterBuilderActivity_ActivityEditionSchedule(),
    Activity_ActivityEditionScheduleRelationBuilder,
    Activity_ActivityEditionScheduleParser
  ),

ActivityEditionN_ActivityEditionSchedule: () => mk_rel_query(
    'ActivityEditionN_ActivityEditionSchedule',
    FilterBuilderActivityEditionN_ActivityEditionSchedule(),
    ActivityEditionN_ActivityEditionScheduleRelationBuilder,
    ActivityEditionN_ActivityEditionScheduleParser
  ),

Location_ActivityEditionSchedule: () => mk_rel_query(
    'Location_ActivityEditionSchedule',
    FilterBuilderLocation_ActivityEditionSchedule(),
    Location_ActivityEditionScheduleRelationBuilder,
    Location_ActivityEditionScheduleParser
  ),

}


const  ActivityEditionScheduleParser : EntityParser<ActivityEditionSchedule>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Plan: parseNullString,
  Activity_ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
      ActivityEditionN_ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
      Location_ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityEditionScheduleOrderBy : (p: string) => OrderByBuilderComplex<ActivityEditionSchedule> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Plan:  new OrderByProp(p ? p + "/Plan" : "Plan"),
  Activity_ActivityEditionSchedule:  p => Activity_ActivityEditionScheduleOrderBy(p ? p + "/Activity_ActivityEditionSchedule" : "Activity_ActivityEditionSchedule"),
      ActivityEditionN_ActivityEditionSchedule:  p => ActivityEditionN_ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionN_ActivityEditionSchedule" : "ActivityEditionN_ActivityEditionSchedule"),
      Location_ActivityEditionSchedule:  p => Location_ActivityEditionScheduleOrderBy(p ? p + "/Location_ActivityEditionSchedule" : "Location_ActivityEditionSchedule"),
})



export type ActivityEvent = {
    Id: number
    CreatedDate: Date
    Date: Date
    Start: string | null
    End: string | null
} & {
  ActivityEditionN_ActivityEvent: List<ActivityEditionN_ActivityEvent>
    Location_ActivityEvent: List<Location_ActivityEvent>
}


function FilterBuilderActivityEvent(prefix?: string) : FilterBuilderComplex<ActivityEvent> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Date: new FilterBuilderDate(mk_prefix('Date', prefix)),
      Start: new FilterBuilderString(mk_prefix('Start', prefix)),
      End: new FilterBuilderString(mk_prefix('End', prefix)),
    ActivityEditionN_ActivityEvent: new FilterBuilderCollection<ActivityEditionN_ActivityEvent>(mk_prefix('ActivityEditionN_ActivityEvent', prefix), s => FilterBuilderActivityEditionN_ActivityEvent(s)),
      Location_ActivityEvent: new FilterBuilderCollection<Location_ActivityEvent>(mk_prefix('Location_ActivityEvent', prefix), s => FilterBuilderLocation_ActivityEvent(s)),
  }
}


const ActivityEventRelationBuilder: RelationBuilder<RelationsOf<ActivityEvent>> = {
ActivityEditionN_ActivityEvent: () => mk_rel_query(
    'ActivityEditionN_ActivityEvent',
    FilterBuilderActivityEditionN_ActivityEvent(),
    ActivityEditionN_ActivityEventRelationBuilder,
    ActivityEditionN_ActivityEventParser
  ),

Location_ActivityEvent: () => mk_rel_query(
    'Location_ActivityEvent',
    FilterBuilderLocation_ActivityEvent(),
    Location_ActivityEventRelationBuilder,
    Location_ActivityEventParser
  ),

}


const  ActivityEventParser : EntityParser<ActivityEvent>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Date: parseDate,
      Start: parseNullString,
      End: parseNullString,
  ActivityEditionN_ActivityEvent: p => parseCollection(x => parseEntity(x, p)),
      Location_ActivityEvent: p => parseCollection(x => parseEntity(x, p)),
}


const ActivityEventOrderBy : (p: string) => OrderByBuilderComplex<ActivityEvent> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Date:  new OrderByProp(p ? p + "/Date" : "Date"),
      Start:  new OrderByProp(p ? p + "/Start" : "Start"),
      End:  new OrderByProp(p ? p + "/End" : "End"),
  ActivityEditionN_ActivityEvent:  p => ActivityEditionN_ActivityEventOrderBy(p ? p + "/ActivityEditionN_ActivityEvent" : "ActivityEditionN_ActivityEvent"),
      Location_ActivityEvent:  p => Location_ActivityEventOrderBy(p ? p + "/Location_ActivityEvent" : "Location_ActivityEvent"),
})



export type Admin = {
    Id: number
    CreatedDate: Date
    Username: string | null
    Language: string | null
    Email: string | null
    PasswordHash: string | null
    PasswordSalt: string | null
    LastLoginAttempt: Date
    SecurityStamp: string | null
    EmailConfirmed: boolean
} & {

}


function FilterBuilderAdmin(prefix?: string) : FilterBuilderComplex<Admin> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Username: new FilterBuilderString(mk_prefix('Username', prefix)),
      Language: new FilterBuilderString(mk_prefix('Language', prefix)),
      Email: new FilterBuilderString(mk_prefix('Email', prefix)),
      PasswordHash: new FilterBuilderString(mk_prefix('PasswordHash', prefix)),
      PasswordSalt: new FilterBuilderString(mk_prefix('PasswordSalt', prefix)),
      LastLoginAttempt: new FilterBuilderDate(mk_prefix('LastLoginAttempt', prefix)),
      SecurityStamp: new FilterBuilderString(mk_prefix('SecurityStamp', prefix)),
      EmailConfirmed: new FilterBuilderBoolean(mk_prefix('EmailConfirmed', prefix)),
    
  }
}


const AdminRelationBuilder: RelationBuilder<RelationsOf<Admin>> = {

}


const  AdminParser : EntityParser<Admin>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Username: parseNullString,
      Language: parseNullString,
      Email: parseNullString,
      PasswordHash: parseNullString,
      PasswordSalt: parseNullString,
      LastLoginAttempt: parseDate,
      SecurityStamp: parseNullString,
      EmailConfirmed: parseBoolean,
  
}


const AdminOrderBy : (p: string) => OrderByBuilderComplex<Admin> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Username:  new OrderByProp(p ? p + "/Username" : "Username"),
      Language:  new OrderByProp(p ? p + "/Language" : "Language"),
      Email:  new OrderByProp(p ? p + "/Email" : "Email"),
      PasswordHash:  new OrderByProp(p ? p + "/PasswordHash" : "PasswordHash"),
      PasswordSalt:  new OrderByProp(p ? p + "/PasswordSalt" : "PasswordSalt"),
      LastLoginAttempt:  new OrderByProp(p ? p + "/LastLoginAttempt" : "LastLoginAttempt"),
      SecurityStamp:  new OrderByProp(p ? p + "/SecurityStamp" : "SecurityStamp"),
      EmailConfirmed:  new OrderByProp(p ? p + "/EmailConfirmed" : "EmailConfirmed"),
  
})



export type ArchivedActivityEditionN = {
    Id: number
    CreatedDate: Date
    SignupText: string | null
    SignupURL: string | null
} & {
  Activity_ArchivedActivityEditionN: List<Activity_ArchivedActivityEditionN>
    ArchivedActivityEditionN_ArchivedActivityEvent: List<ArchivedActivityEditionN_ArchivedActivityEvent>
    ArchivedActivityEditionN_Book: List<ArchivedActivityEditionN_Book>
}


function FilterBuilderArchivedActivityEditionN(prefix?: string) : FilterBuilderComplex<ArchivedActivityEditionN> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      SignupText: new FilterBuilderString(mk_prefix('SignupText', prefix)),
      SignupURL: new FilterBuilderString(mk_prefix('SignupURL', prefix)),
    Activity_ArchivedActivityEditionN: new FilterBuilderCollection<Activity_ArchivedActivityEditionN>(mk_prefix('Activity_ArchivedActivityEditionN', prefix), s => FilterBuilderActivity_ArchivedActivityEditionN(s)),
      ArchivedActivityEditionN_ArchivedActivityEvent: new FilterBuilderCollection<ArchivedActivityEditionN_ArchivedActivityEvent>(mk_prefix('ArchivedActivityEditionN_ArchivedActivityEvent', prefix), s => FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(s)),
      ArchivedActivityEditionN_Book: new FilterBuilderCollection<ArchivedActivityEditionN_Book>(mk_prefix('ArchivedActivityEditionN_Book', prefix), s => FilterBuilderArchivedActivityEditionN_Book(s)),
  }
}


const ArchivedActivityEditionNRelationBuilder: RelationBuilder<RelationsOf<ArchivedActivityEditionN>> = {
Activity_ArchivedActivityEditionN: () => mk_rel_query(
    'Activity_ArchivedActivityEditionN',
    FilterBuilderActivity_ArchivedActivityEditionN(),
    Activity_ArchivedActivityEditionNRelationBuilder,
    Activity_ArchivedActivityEditionNParser
  ),

ArchivedActivityEditionN_ArchivedActivityEvent: () => mk_rel_query(
    'ArchivedActivityEditionN_ArchivedActivityEvent',
    FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(),
    ArchivedActivityEditionN_ArchivedActivityEventRelationBuilder,
    ArchivedActivityEditionN_ArchivedActivityEventParser
  ),

ArchivedActivityEditionN_Book: () => mk_rel_query(
    'ArchivedActivityEditionN_Book',
    FilterBuilderArchivedActivityEditionN_Book(),
    ArchivedActivityEditionN_BookRelationBuilder,
    ArchivedActivityEditionN_BookParser
  ),

}


const  ArchivedActivityEditionNParser : EntityParser<ArchivedActivityEditionN>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      SignupText: parseNullString,
      SignupURL: parseNullString,
  Activity_ArchivedActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      ArchivedActivityEditionN_ArchivedActivityEvent: p => parseCollection(x => parseEntity(x, p)),
      ArchivedActivityEditionN_Book: p => parseCollection(x => parseEntity(x, p)),
}


const ArchivedActivityEditionNOrderBy : (p: string) => OrderByBuilderComplex<ArchivedActivityEditionN> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      SignupText:  new OrderByProp(p ? p + "/SignupText" : "SignupText"),
      SignupURL:  new OrderByProp(p ? p + "/SignupURL" : "SignupURL"),
  Activity_ArchivedActivityEditionN:  p => Activity_ArchivedActivityEditionNOrderBy(p ? p + "/Activity_ArchivedActivityEditionN" : "Activity_ArchivedActivityEditionN"),
      ArchivedActivityEditionN_ArchivedActivityEvent:  p => ArchivedActivityEditionN_ArchivedActivityEventOrderBy(p ? p + "/ArchivedActivityEditionN_ArchivedActivityEvent" : "ArchivedActivityEditionN_ArchivedActivityEvent"),
      ArchivedActivityEditionN_Book:  p => ArchivedActivityEditionN_BookOrderBy(p ? p + "/ArchivedActivityEditionN_Book" : "ArchivedActivityEditionN_Book"),
})



export type ArchivedActivityEditionN_ArchivedActivityEvent = {
    Id: number
    ArchivedActivityEditionNId: number
    ArchivedActivityEventId: number
} & {
  ArchivedActivityEditionN: List<ArchivedActivityEditionN>
    ArchivedActivityEvent: List<ArchivedActivityEvent>
}


function FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(prefix?: string) : FilterBuilderComplex<ArchivedActivityEditionN_ArchivedActivityEvent> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ArchivedActivityEditionNId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEditionNId', prefix)),
      ArchivedActivityEventId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEventId', prefix)),
    ArchivedActivityEditionN: new FilterBuilderCollection<ArchivedActivityEditionN>(mk_prefix('ArchivedActivityEditionN', prefix), s => FilterBuilderArchivedActivityEditionN(s)),
      ArchivedActivityEvent: new FilterBuilderCollection<ArchivedActivityEvent>(mk_prefix('ArchivedActivityEvent', prefix), s => FilterBuilderArchivedActivityEvent(s)),
  }
}


const ArchivedActivityEditionN_ArchivedActivityEventRelationBuilder: RelationBuilder<RelationsOf<ArchivedActivityEditionN_ArchivedActivityEvent>> = {
ArchivedActivityEditionN: () => mk_rel_query(
    'ArchivedActivityEditionN',
    FilterBuilderArchivedActivityEditionN(),
    ArchivedActivityEditionNRelationBuilder,
    ArchivedActivityEditionNParser
  ),

ArchivedActivityEvent: () => mk_rel_query(
    'ArchivedActivityEvent',
    FilterBuilderArchivedActivityEvent(),
    ArchivedActivityEventRelationBuilder,
    ArchivedActivityEventParser
  ),

}


const  ArchivedActivityEditionN_ArchivedActivityEventParser : EntityParser<ArchivedActivityEditionN_ArchivedActivityEvent>= {
  Id: parseNumber,
      ArchivedActivityEditionNId: parseNumber,
      ArchivedActivityEventId: parseNumber,
  ArchivedActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      ArchivedActivityEvent: p => parseCollection(x => parseEntity(x, p)),
}


const ArchivedActivityEditionN_ArchivedActivityEventOrderBy : (p: string) => OrderByBuilderComplex<ArchivedActivityEditionN_ArchivedActivityEvent> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ArchivedActivityEditionNId:  new OrderByProp(p ? p + "/ArchivedActivityEditionNId" : "ArchivedActivityEditionNId"),
      ArchivedActivityEventId:  new OrderByProp(p ? p + "/ArchivedActivityEventId" : "ArchivedActivityEventId"),
  ArchivedActivityEditionN:  p => ArchivedActivityEditionNOrderBy(p ? p + "/ArchivedActivityEditionN" : "ArchivedActivityEditionN"),
      ArchivedActivityEvent:  p => ArchivedActivityEventOrderBy(p ? p + "/ArchivedActivityEvent" : "ArchivedActivityEvent"),
})



export type ArchivedActivityEditionN_Book = {
    Id: number
    ArchivedActivityEditionNId: number
    BookId: number
} & {
  ArchivedActivityEditionN: List<ArchivedActivityEditionN>
    Book: List<Book>
}


function FilterBuilderArchivedActivityEditionN_Book(prefix?: string) : FilterBuilderComplex<ArchivedActivityEditionN_Book> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      ArchivedActivityEditionNId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEditionNId', prefix)),
      BookId: new FilterBuilderNumber(mk_prefix('BookId', prefix)),
    ArchivedActivityEditionN: new FilterBuilderCollection<ArchivedActivityEditionN>(mk_prefix('ArchivedActivityEditionN', prefix), s => FilterBuilderArchivedActivityEditionN(s)),
      Book: new FilterBuilderCollection<Book>(mk_prefix('Book', prefix), s => FilterBuilderBook(s)),
  }
}


const ArchivedActivityEditionN_BookRelationBuilder: RelationBuilder<RelationsOf<ArchivedActivityEditionN_Book>> = {
ArchivedActivityEditionN: () => mk_rel_query(
    'ArchivedActivityEditionN',
    FilterBuilderArchivedActivityEditionN(),
    ArchivedActivityEditionNRelationBuilder,
    ArchivedActivityEditionNParser
  ),

Book: () => mk_rel_query(
    'Book',
    FilterBuilderBook(),
    BookRelationBuilder,
    BookParser
  ),

}


const  ArchivedActivityEditionN_BookParser : EntityParser<ArchivedActivityEditionN_Book>= {
  Id: parseNumber,
      ArchivedActivityEditionNId: parseNumber,
      BookId: parseNumber,
  ArchivedActivityEditionN: p => parseCollection(x => parseEntity(x, p)),
      Book: p => parseCollection(x => parseEntity(x, p)),
}


const ArchivedActivityEditionN_BookOrderBy : (p: string) => OrderByBuilderComplex<ArchivedActivityEditionN_Book> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      ArchivedActivityEditionNId:  new OrderByProp(p ? p + "/ArchivedActivityEditionNId" : "ArchivedActivityEditionNId"),
      BookId:  new OrderByProp(p ? p + "/BookId" : "BookId"),
  ArchivedActivityEditionN:  p => ArchivedActivityEditionNOrderBy(p ? p + "/ArchivedActivityEditionN" : "ArchivedActivityEditionN"),
      Book:  p => BookOrderBy(p ? p + "/Book" : "Book"),
})



export type ArchivedActivityEvent = {
    Id: number
    CreatedDate: Date
    Date: Date
    Start: string | null
    End: string | null
} & {
  ArchivedActivityEditionN_ArchivedActivityEvent: List<ArchivedActivityEditionN_ArchivedActivityEvent>
    Location_ArchivedActivityEvent: List<Location_ArchivedActivityEvent>
}


function FilterBuilderArchivedActivityEvent(prefix?: string) : FilterBuilderComplex<ArchivedActivityEvent> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Date: new FilterBuilderDate(mk_prefix('Date', prefix)),
      Start: new FilterBuilderString(mk_prefix('Start', prefix)),
      End: new FilterBuilderString(mk_prefix('End', prefix)),
    ArchivedActivityEditionN_ArchivedActivityEvent: new FilterBuilderCollection<ArchivedActivityEditionN_ArchivedActivityEvent>(mk_prefix('ArchivedActivityEditionN_ArchivedActivityEvent', prefix), s => FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(s)),
      Location_ArchivedActivityEvent: new FilterBuilderCollection<Location_ArchivedActivityEvent>(mk_prefix('Location_ArchivedActivityEvent', prefix), s => FilterBuilderLocation_ArchivedActivityEvent(s)),
  }
}


const ArchivedActivityEventRelationBuilder: RelationBuilder<RelationsOf<ArchivedActivityEvent>> = {
ArchivedActivityEditionN_ArchivedActivityEvent: () => mk_rel_query(
    'ArchivedActivityEditionN_ArchivedActivityEvent',
    FilterBuilderArchivedActivityEditionN_ArchivedActivityEvent(),
    ArchivedActivityEditionN_ArchivedActivityEventRelationBuilder,
    ArchivedActivityEditionN_ArchivedActivityEventParser
  ),

Location_ArchivedActivityEvent: () => mk_rel_query(
    'Location_ArchivedActivityEvent',
    FilterBuilderLocation_ArchivedActivityEvent(),
    Location_ArchivedActivityEventRelationBuilder,
    Location_ArchivedActivityEventParser
  ),

}


const  ArchivedActivityEventParser : EntityParser<ArchivedActivityEvent>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Date: parseDate,
      Start: parseNullString,
      End: parseNullString,
  ArchivedActivityEditionN_ArchivedActivityEvent: p => parseCollection(x => parseEntity(x, p)),
      Location_ArchivedActivityEvent: p => parseCollection(x => parseEntity(x, p)),
}


const ArchivedActivityEventOrderBy : (p: string) => OrderByBuilderComplex<ArchivedActivityEvent> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Date:  new OrderByProp(p ? p + "/Date" : "Date"),
      Start:  new OrderByProp(p ? p + "/Start" : "Start"),
      End:  new OrderByProp(p ? p + "/End" : "End"),
  ArchivedActivityEditionN_ArchivedActivityEvent:  p => ArchivedActivityEditionN_ArchivedActivityEventOrderBy(p ? p + "/ArchivedActivityEditionN_ArchivedActivityEvent" : "ArchivedActivityEditionN_ArchivedActivityEvent"),
      Location_ArchivedActivityEvent:  p => Location_ArchivedActivityEventOrderBy(p ? p + "/Location_ArchivedActivityEvent" : "Location_ArchivedActivityEvent"),
})



export type Book = {
    Id: number
    CreatedDate: Date
    Name: string | null
    Author: string | null
    Image: string | null
    URL: string | null
} & {
  ActivityEditionN_Book: List<ActivityEditionN_Book>
    ArchivedActivityEditionN_Book: List<ArchivedActivityEditionN_Book>
    Book_ImageData: List<Book_ImageData>
}


function FilterBuilderBook(prefix?: string) : FilterBuilderComplex<Book> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Name: new FilterBuilderString(mk_prefix('Name', prefix)),
      Author: new FilterBuilderString(mk_prefix('Author', prefix)),
      Image: new FilterBuilderString(mk_prefix('Image', prefix)),
      URL: new FilterBuilderString(mk_prefix('URL', prefix)),
    ActivityEditionN_Book: new FilterBuilderCollection<ActivityEditionN_Book>(mk_prefix('ActivityEditionN_Book', prefix), s => FilterBuilderActivityEditionN_Book(s)),
      ArchivedActivityEditionN_Book: new FilterBuilderCollection<ArchivedActivityEditionN_Book>(mk_prefix('ArchivedActivityEditionN_Book', prefix), s => FilterBuilderArchivedActivityEditionN_Book(s)),
      Book_ImageData: new FilterBuilderCollection<Book_ImageData>(mk_prefix('Book_ImageData', prefix), s => FilterBuilderBook_ImageData(s)),
  }
}


const BookRelationBuilder: RelationBuilder<RelationsOf<Book>> = {
ActivityEditionN_Book: () => mk_rel_query(
    'ActivityEditionN_Book',
    FilterBuilderActivityEditionN_Book(),
    ActivityEditionN_BookRelationBuilder,
    ActivityEditionN_BookParser
  ),

ArchivedActivityEditionN_Book: () => mk_rel_query(
    'ArchivedActivityEditionN_Book',
    FilterBuilderArchivedActivityEditionN_Book(),
    ArchivedActivityEditionN_BookRelationBuilder,
    ArchivedActivityEditionN_BookParser
  ),

Book_ImageData: () => mk_rel_query(
    'Book_ImageData',
    FilterBuilderBook_ImageData(),
    Book_ImageDataRelationBuilder,
    Book_ImageDataParser
  ),

}


const  BookParser : EntityParser<Book>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Name: parseNullString,
      Author: parseNullString,
      Image: parseNullString,
      URL: parseNullString,
  ActivityEditionN_Book: p => parseCollection(x => parseEntity(x, p)),
      ArchivedActivityEditionN_Book: p => parseCollection(x => parseEntity(x, p)),
      Book_ImageData: p => parseCollection(x => parseEntity(x, p)),
}


const BookOrderBy : (p: string) => OrderByBuilderComplex<Book> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Name:  new OrderByProp(p ? p + "/Name" : "Name"),
      Author:  new OrderByProp(p ? p + "/Author" : "Author"),
      Image:  new OrderByProp(p ? p + "/Image" : "Image"),
      URL:  new OrderByProp(p ? p + "/URL" : "URL"),
  ActivityEditionN_Book:  p => ActivityEditionN_BookOrderBy(p ? p + "/ActivityEditionN_Book" : "ActivityEditionN_Book"),
      ArchivedActivityEditionN_Book:  p => ArchivedActivityEditionN_BookOrderBy(p ? p + "/ArchivedActivityEditionN_Book" : "ArchivedActivityEditionN_Book"),
      Book_ImageData:  p => Book_ImageDataOrderBy(p ? p + "/Book_ImageData" : "Book_ImageData"),
})



export type Book_ImageData = {
    Id: number
    Content: string | null
    FileName: string | null
    ContentType: string | null
    BookId: number
} & {
  Book: List<Book>
}


function FilterBuilderBook_ImageData(prefix?: string) : FilterBuilderComplex<Book_ImageData> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      Content: new FilterBuilderString(mk_prefix('Content', prefix)),
      FileName: new FilterBuilderString(mk_prefix('FileName', prefix)),
      ContentType: new FilterBuilderString(mk_prefix('ContentType', prefix)),
      BookId: new FilterBuilderNumber(mk_prefix('BookId', prefix)),
    Book: new FilterBuilderCollection<Book>(mk_prefix('Book', prefix), s => FilterBuilderBook(s)),
  }
}


const Book_ImageDataRelationBuilder: RelationBuilder<RelationsOf<Book_ImageData>> = {
Book: () => mk_rel_query(
    'Book',
    FilterBuilderBook(),
    BookRelationBuilder,
    BookParser
  ),

}


const  Book_ImageDataParser : EntityParser<Book_ImageData>= {
  Id: parseNumber,
      Content: parseNullString,
      FileName: parseNullString,
      ContentType: parseNullString,
      BookId: parseNumber,
  Book: p => parseCollection(x => parseEntity(x, p)),
}


const Book_ImageDataOrderBy : (p: string) => OrderByBuilderComplex<Book_ImageData> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      Content:  new OrderByProp(p ? p + "/Content" : "Content"),
      FileName:  new OrderByProp(p ? p + "/FileName" : "FileName"),
      ContentType:  new OrderByProp(p ? p + "/ContentType" : "ContentType"),
      BookId:  new OrderByProp(p ? p + "/BookId" : "BookId"),
  Book:  p => BookOrderBy(p ? p + "/Book" : "Book"),
})



export type ControlPanel = {
    Id: number
    CreatedDate: Date
} & {

}


function FilterBuilderControlPanel(prefix?: string) : FilterBuilderComplex<ControlPanel> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
    
  }
}


const ControlPanelRelationBuilder: RelationBuilder<RelationsOf<ControlPanel>> = {

}


const  ControlPanelParser : EntityParser<ControlPanel>= {
  Id: parseNumber,
      CreatedDate: parseDate,
  
}


const ControlPanelOrderBy : (p: string) => OrderByBuilderComplex<ControlPanel> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
  
})



export type HomePage = {
    Id: number
    CreatedDate: Date
} & {

}


function FilterBuilderHomePage(prefix?: string) : FilterBuilderComplex<HomePage> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
    
  }
}


const HomePageRelationBuilder: RelationBuilder<RelationsOf<HomePage>> = {

}


const  HomePageParser : EntityParser<HomePage>= {
  Id: parseNumber,
      CreatedDate: parseDate,
  
}


const HomePageOrderBy : (p: string) => OrderByBuilderComplex<HomePage> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
  
})



export type Location = {
    Id: number
    CreatedDate: Date
    Title: string | null
    Adres: string | null
} & {
  Location_ActivityEditionSchedule: List<Location_ActivityEditionSchedule>
    Location_ActivityEvent: List<Location_ActivityEvent>
    Location_ArchivedActivityEvent: List<Location_ArchivedActivityEvent>
    Region_Location: List<Region_Location>
}


function FilterBuilderLocation(prefix?: string) : FilterBuilderComplex<Location> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Title: new FilterBuilderString(mk_prefix('Title', prefix)),
      Adres: new FilterBuilderString(mk_prefix('Adres', prefix)),
    Location_ActivityEditionSchedule: new FilterBuilderCollection<Location_ActivityEditionSchedule>(mk_prefix('Location_ActivityEditionSchedule', prefix), s => FilterBuilderLocation_ActivityEditionSchedule(s)),
      Location_ActivityEvent: new FilterBuilderCollection<Location_ActivityEvent>(mk_prefix('Location_ActivityEvent', prefix), s => FilterBuilderLocation_ActivityEvent(s)),
      Location_ArchivedActivityEvent: new FilterBuilderCollection<Location_ArchivedActivityEvent>(mk_prefix('Location_ArchivedActivityEvent', prefix), s => FilterBuilderLocation_ArchivedActivityEvent(s)),
      Region_Location: new FilterBuilderCollection<Region_Location>(mk_prefix('Region_Location', prefix), s => FilterBuilderRegion_Location(s)),
  }
}

const LocationRelationBuilder: RelationBuilder<RelationsOf<Location>> = {
Location_ActivityEditionSchedule: () => mk_rel_query(
    'Location_ActivityEditionSchedule',
    FilterBuilderLocation_ActivityEditionSchedule(),
    Location_ActivityEditionScheduleRelationBuilder,
    Location_ActivityEditionScheduleParser
  ),

Location_ActivityEvent: () => mk_rel_query(
    'Location_ActivityEvent',
    FilterBuilderLocation_ActivityEvent(),
    Location_ActivityEventRelationBuilder,
    Location_ActivityEventParser
  ),

Location_ArchivedActivityEvent: () => mk_rel_query(
    'Location_ArchivedActivityEvent',
    FilterBuilderLocation_ArchivedActivityEvent(),
    Location_ArchivedActivityEventRelationBuilder,
    Location_ArchivedActivityEventParser
  ),

Region_Location: () => mk_rel_query(
    'Region_Location',
    FilterBuilderRegion_Location(),
    Region_LocationRelationBuilder,
    Region_LocationParser
  ),

}


const  LocationParser : EntityParser<Location>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Title: parseNullString,
      Adres: parseNullString,
  Location_ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
      Location_ActivityEvent: p => parseCollection(x => parseEntity(x, p)),
      Location_ArchivedActivityEvent: p => parseCollection(x => parseEntity(x, p)),
      Region_Location: p => parseCollection(x => parseEntity(x, p)),
}


const LocationOrderBy : (p: string) => OrderByBuilderComplex<Location> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Title:  new OrderByProp(p ? p + "/Title" : "Title"),
      Adres: new OrderByProp(p ? p + "/Adres" : "Adres"),
  Location_ActivityEditionSchedule:  p => Location_ActivityEditionScheduleOrderBy(p ? p + "/Location_ActivityEditionSchedule" : "Location_ActivityEditionSchedule"),
      Location_ActivityEvent:  p => Location_ActivityEventOrderBy(p ? p + "/Location_ActivityEvent" : "Location_ActivityEvent"),
      Location_ArchivedActivityEvent:  p => Location_ArchivedActivityEventOrderBy(p ? p + "/Location_ArchivedActivityEvent" : "Location_ArchivedActivityEvent"),
      Region_Location:  p => Region_LocationOrderBy(p ? p + "/Region_Location" : "Region_Location"),
})



export type Location_ActivityEditionSchedule = {
    Id: number
    LocationId: number
    ActivityEditionScheduleId: number
} & {
  ActivityEditionSchedule: List<ActivityEditionSchedule>
    Location: List<Location>
}


function FilterBuilderLocation_ActivityEditionSchedule(prefix?: string) : FilterBuilderComplex<Location_ActivityEditionSchedule> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LocationId: new FilterBuilderNumber(mk_prefix('LocationId', prefix)),
      ActivityEditionScheduleId: new FilterBuilderNumber(mk_prefix('ActivityEditionScheduleId', prefix)),
    ActivityEditionSchedule: new FilterBuilderCollection<ActivityEditionSchedule>(mk_prefix('ActivityEditionSchedule', prefix), s => FilterBuilderActivityEditionSchedule(s)),
      Location: new FilterBuilderCollection<Location>(mk_prefix('Location', prefix), s => FilterBuilderLocation(s)),
  }
}


const Location_ActivityEditionScheduleRelationBuilder: RelationBuilder<RelationsOf<Location_ActivityEditionSchedule>> = {
ActivityEditionSchedule: () => mk_rel_query(
    'ActivityEditionSchedule',
    FilterBuilderActivityEditionSchedule(),
    ActivityEditionScheduleRelationBuilder,
    ActivityEditionScheduleParser
  ),

Location: () => mk_rel_query(
    'Location',
    FilterBuilderLocation(),
    LocationRelationBuilder,
    LocationParser
  ),

}


const  Location_ActivityEditionScheduleParser : EntityParser<Location_ActivityEditionSchedule>= {
  Id: parseNumber,
      LocationId: parseNumber,
      ActivityEditionScheduleId: parseNumber,
  ActivityEditionSchedule: p => parseCollection(x => parseEntity(x, p)),
      Location: p => parseCollection(x => parseEntity(x, p)),
}


const Location_ActivityEditionScheduleOrderBy : (p: string) => OrderByBuilderComplex<Location_ActivityEditionSchedule> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LocationId:  new OrderByProp(p ? p + "/LocationId" : "LocationId"),
      ActivityEditionScheduleId:  new OrderByProp(p ? p + "/ActivityEditionScheduleId" : "ActivityEditionScheduleId"),
  ActivityEditionSchedule:  p => ActivityEditionScheduleOrderBy(p ? p + "/ActivityEditionSchedule" : "ActivityEditionSchedule"),
      Location:  p => LocationOrderBy(p ? p + "/Location" : "Location"),
})



export type Location_ActivityEvent = {
    Id: number
    LocationId: number
    ActivityEventId: number
} & {
  ActivityEvent: List<ActivityEvent>
    Location: List<Location>
}


function FilterBuilderLocation_ActivityEvent(prefix?: string) : FilterBuilderComplex<Location_ActivityEvent> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LocationId: new FilterBuilderNumber(mk_prefix('LocationId', prefix)),
      ActivityEventId: new FilterBuilderNumber(mk_prefix('ActivityEventId', prefix)),
    ActivityEvent: new FilterBuilderCollection<ActivityEvent>(mk_prefix('ActivityEvent', prefix), s => FilterBuilderActivityEvent(s)),
      Location: new FilterBuilderCollection<Location>(mk_prefix('Location', prefix), s => FilterBuilderLocation(s)),
  }
}


const Location_ActivityEventRelationBuilder: RelationBuilder<RelationsOf<Location_ActivityEvent>> = {
ActivityEvent: () => mk_rel_query(
    'ActivityEvent',
    FilterBuilderActivityEvent(),
    ActivityEventRelationBuilder,
    ActivityEventParser
  ),

Location: () => mk_rel_query(
    'Location',
    FilterBuilderLocation(),
    LocationRelationBuilder,
    LocationParser
  ),

}


const  Location_ActivityEventParser : EntityParser<Location_ActivityEvent>= {
  Id: parseNumber,
      LocationId: parseNumber,
      ActivityEventId: parseNumber,
  ActivityEvent: p => parseCollection(x => parseEntity(x, p)),
      Location: p => parseCollection(x => parseEntity(x, p)),
}


const Location_ActivityEventOrderBy : (p: string) => OrderByBuilderComplex<Location_ActivityEvent> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LocationId:  new OrderByProp(p ? p + "/LocationId" : "LocationId"),
      ActivityEventId:  new OrderByProp(p ? p + "/ActivityEventId" : "ActivityEventId"),
  ActivityEvent:  p => ActivityEventOrderBy(p ? p + "/ActivityEvent" : "ActivityEvent"),
      Location:  p => LocationOrderBy(p ? p + "/Location" : "Location"),
})



export type Location_ArchivedActivityEvent = {
    Id: number
    LocationId: number
    ArchivedActivityEventId: number
} & {
  ArchivedActivityEvent: List<ArchivedActivityEvent>
    Location: List<Location>
}


function FilterBuilderLocation_ArchivedActivityEvent(prefix?: string) : FilterBuilderComplex<Location_ArchivedActivityEvent> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LocationId: new FilterBuilderNumber(mk_prefix('LocationId', prefix)),
      ArchivedActivityEventId: new FilterBuilderNumber(mk_prefix('ArchivedActivityEventId', prefix)),
    ArchivedActivityEvent: new FilterBuilderCollection<ArchivedActivityEvent>(mk_prefix('ArchivedActivityEvent', prefix), s => FilterBuilderArchivedActivityEvent(s)),
      Location: new FilterBuilderCollection<Location>(mk_prefix('Location', prefix), s => FilterBuilderLocation(s)),
  }
}


const Location_ArchivedActivityEventRelationBuilder: RelationBuilder<RelationsOf<Location_ArchivedActivityEvent>> = {
ArchivedActivityEvent: () => mk_rel_query(
    'ArchivedActivityEvent',
    FilterBuilderArchivedActivityEvent(),
    ArchivedActivityEventRelationBuilder,
    ArchivedActivityEventParser
  ),

Location: () => mk_rel_query(
    'Location',
    FilterBuilderLocation(),
    LocationRelationBuilder,
    LocationParser
  ),

}


const  Location_ArchivedActivityEventParser : EntityParser<Location_ArchivedActivityEvent>= {
  Id: parseNumber,
      LocationId: parseNumber,
      ArchivedActivityEventId: parseNumber,
  ArchivedActivityEvent: p => parseCollection(x => parseEntity(x, p)),
      Location: p => parseCollection(x => parseEntity(x, p)),
}


const Location_ArchivedActivityEventOrderBy : (p: string) => OrderByBuilderComplex<Location_ArchivedActivityEvent> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LocationId:  new OrderByProp(p ? p + "/LocationId" : "LocationId"),
      ArchivedActivityEventId:  new OrderByProp(p ? p + "/ArchivedActivityEventId" : "ArchivedActivityEventId"),
  ArchivedActivityEvent:  p => ArchivedActivityEventOrderBy(p ? p + "/ArchivedActivityEvent" : "ArchivedActivityEvent"),
      Location:  p => LocationOrderBy(p ? p + "/Location" : "Location"),
})



export type LoginAttempt = {
    IpAddress: string | null
    Email: string | null
    Attempts: number
    LastAttempt: Date
} & {

}


function FilterBuilderLoginAttempt(prefix?: string) : FilterBuilderComplex<LoginAttempt> {
  return {
    IpAddress: new FilterBuilderString(mk_prefix('IpAddress', prefix)),
      Email: new FilterBuilderString(mk_prefix('Email', prefix)),
      Attempts: new FilterBuilderNumber(mk_prefix('Attempts', prefix)),
      LastAttempt: new FilterBuilderDate(mk_prefix('LastAttempt', prefix)),
    
  }
}


const LoginAttemptRelationBuilder: RelationBuilder<RelationsOf<LoginAttempt>> = {

}


const  LoginAttemptParser : EntityParser<LoginAttempt>= {
  IpAddress: parseNullString,
      Email: parseNullString,
      Attempts: parseNumber,
      LastAttempt: parseDate,
  
}


const LoginAttemptOrderBy : (p: string) => OrderByBuilderComplex<LoginAttempt> = p => ({
  IpAddress:  new OrderByProp(p ? p + "/IpAddress" : "IpAddress"),
      Email:  new OrderByProp(p ? p + "/Email" : "Email"),
      Attempts:  new OrderByProp(p ? p + "/Attempts" : "Attempts"),
      LastAttempt:  new OrderByProp(p ? p + "/LastAttempt" : "LastAttempt"),
  
})



export type PermanentRedirect = {
    Id: number
    CreatedDate: Date
    OldUrl: string | null
    NewUrl: string | null
} & {

}


function FilterBuilderPermanentRedirect(prefix?: string) : FilterBuilderComplex<PermanentRedirect> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      OldUrl: new FilterBuilderString(mk_prefix('OldUrl', prefix)),
      NewUrl: new FilterBuilderString(mk_prefix('NewUrl', prefix)),
    
  }
}


const PermanentRedirectRelationBuilder: RelationBuilder<RelationsOf<PermanentRedirect>> = {

}


const  PermanentRedirectParser : EntityParser<PermanentRedirect>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      OldUrl: parseNullString,
      NewUrl: parseNullString,
  
}


const PermanentRedirectOrderBy : (p: string) => OrderByBuilderComplex<PermanentRedirect> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      OldUrl:  new OrderByProp(p ? p + "/OldUrl" : "OldUrl"),
      NewUrl:  new OrderByProp(p ? p + "/NewUrl" : "NewUrl"),
  
})



export type Region = {
    Id: number
    CreatedDate: Date
    Title: string | null
    Slug: string | null
} & {
  Region_Location: List<Region_Location>
}


function FilterBuilderRegion(prefix?: string) : FilterBuilderComplex<Region> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      CreatedDate: new FilterBuilderDate(mk_prefix('CreatedDate', prefix)),
      Title: new FilterBuilderString(mk_prefix('Title', prefix)),
      Slug: new FilterBuilderString(mk_prefix('Slug', prefix)),
    Region_Location: new FilterBuilderCollection<Region_Location>(mk_prefix('Region_Location', prefix), s => FilterBuilderRegion_Location(s)),
  }
}


const RegionRelationBuilder: RelationBuilder<RelationsOf<Region>> = {
Region_Location: () => mk_rel_query(
    'Region_Location',
    FilterBuilderRegion_Location(),
    Region_LocationRelationBuilder,
    Region_LocationParser
  ),

}


const  RegionParser : EntityParser<Region>= {
  Id: parseNumber,
      CreatedDate: parseDate,
      Title: parseNullString,
      Slug: parseNullString,
  Region_Location: p => parseCollection(x => parseEntity(x, p)),
}


const RegionOrderBy : (p: string) => OrderByBuilderComplex<Region> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      CreatedDate:  new OrderByProp(p ? p + "/CreatedDate" : "CreatedDate"),
      Title:  new OrderByProp(p ? p + "/Title" : "Title"),
      Slug:  new OrderByProp(p ? p + "/Slug" : "Slug"),
  Region_Location:  p => Region_LocationOrderBy(p ? p + "/Region_Location" : "Region_Location"),
})



export type Region_Location = {
    Id: number
    RegionId: number
    LocationId: number
} & {
  Location: List<Location>
    Region: List<Region>
}


function FilterBuilderRegion_Location(prefix?: string) : FilterBuilderComplex<Region_Location> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      RegionId: new FilterBuilderNumber(mk_prefix('RegionId', prefix)),
      LocationId: new FilterBuilderNumber(mk_prefix('LocationId', prefix)),
    Location: new FilterBuilderCollection<Location>(mk_prefix('Location', prefix), s => FilterBuilderLocation(s)),
      Region: new FilterBuilderCollection<Region>(mk_prefix('Region', prefix), s => FilterBuilderRegion(s)),
  }
}


const Region_LocationRelationBuilder: RelationBuilder<RelationsOf<Region_Location>> = {
Location: () => mk_rel_query(
    'Location',
    FilterBuilderLocation(),
    LocationRelationBuilder,
    LocationParser
  ),

Region: () => mk_rel_query(
    'Region',
    FilterBuilderRegion(),
    RegionRelationBuilder,
    RegionParser
  ),

}


const  Region_LocationParser : EntityParser<Region_Location>= {
  Id: parseNumber,
      RegionId: parseNumber,
      LocationId: parseNumber,
  Location: p => parseCollection(x => parseEntity(x, p)),
      Region: p => parseCollection(x => parseEntity(x, p)),
}


const Region_LocationOrderBy : (p: string) => OrderByBuilderComplex<Region_Location> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      RegionId:  new OrderByProp(p ? p + "/RegionId" : "RegionId"),
      LocationId:  new OrderByProp(p ? p + "/LocationId" : "LocationId"),
  Location:  p => LocationOrderBy(p ? p + "/Location" : "Location"),
      Region:  p => RegionOrderBy(p ? p + "/Region" : "Region"),
})



export type Session = {
    Id: number
    LoggedEntityId: number | null
    LoggedEntityName: string | null
    AdditionalInfo: string | null
    CookieName: string | null
    Content: string | null
    CreatedAt: Date
    LastInteraction: Date
} & {

}


function FilterBuilderSession(prefix?: string) : FilterBuilderComplex<Session> {
  return {
    Id: new FilterBuilderNumber(mk_prefix('Id', prefix)),
      LoggedEntityId: new FilterBuilderNumber(mk_prefix('LoggedEntityId', prefix)),
      LoggedEntityName: new FilterBuilderString(mk_prefix('LoggedEntityName', prefix)),
      AdditionalInfo: new FilterBuilderString(mk_prefix('AdditionalInfo', prefix)),
      CookieName: new FilterBuilderString(mk_prefix('CookieName', prefix)),
      Content: new FilterBuilderString(mk_prefix('Content', prefix)),
      CreatedAt: new FilterBuilderDate(mk_prefix('CreatedAt', prefix)),
      LastInteraction: new FilterBuilderDate(mk_prefix('LastInteraction', prefix)),
    
  }
}


const SessionRelationBuilder: RelationBuilder<RelationsOf<Session>> = {

}


const  SessionParser : EntityParser<Session>= {
  Id: parseNumber,
      LoggedEntityId: parseNullNumber,
      LoggedEntityName: parseNullString,
      AdditionalInfo: parseNullString,
      CookieName: parseNullString,
      Content: parseNullString,
      CreatedAt: parseDate,
      LastInteraction: parseDate,
  
}


const SessionOrderBy : (p: string) => OrderByBuilderComplex<Session> = p => ({
  Id:  new OrderByProp(p ? p + "/Id" : "Id"),
      LoggedEntityId:  new OrderByProp(p ? p + "/LoggedEntityId" : "LoggedEntityId"),
      LoggedEntityName:  new OrderByProp(p ? p + "/LoggedEntityName" : "LoggedEntityName"),
      AdditionalInfo:  new OrderByProp(p ? p + "/AdditionalInfo" : "AdditionalInfo"),
      CookieName:  new OrderByProp(p ? p + "/CookieName" : "CookieName"),
      Content:  new OrderByProp(p ? p + "/Content" : "Content"),
      CreatedAt:  new OrderByProp(p ? p + "/CreatedAt" : "CreatedAt"),
      LastInteraction:  new OrderByProp(p ? p + "/LastInteraction" : "LastInteraction"),
  
})

